import { defineMessages, IntlShape } from "react-intl";

import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";

import TextGetters from "../types/TextGetters";

const messages = defineMessages({
  count: {
    id: "recordList.pagination.count",
    defaultMessage:
      "{startOffset}—{endOffset} of {total} {total, plural, one {pin} other {pins}} in view",
    description: "Records list's pagination text",
  },
  countLocation: {
    id: "recordList.pagination.countLocation",
    defaultMessage:
      "{startOffset}—{endOffset} of {total} {total, plural, one {record} other {records}} at location",
    description: "Records list's pagination text in location (multi-pin) mode",
  },
  countMono: {
    id: "recordList.pagination.countMono",
    defaultMessage:
      "{startOffset}—{endOffset} of {total} {total, plural, one {{entityType, select, accounts {company} contacts {person} deals {deal} other {record}}} other {{entityType, select, accounts {companies} contacts {people} deals {deals} other {records}}}} in view",
    description: "Records list's pagination text when it consists of a mono-typed entities",
  },
  countSelected: {
    id: "recordList.pagination.countSelected",
    defaultMessage:
      "{startOffset}—{endOffset} of {total} {total, plural, one {pin} other {pins}} selected",
    description: "Records list's pagination text when in lasso selection mode",
  },
});

export const pinsPaginationTextGetterFactory =
  (intl: IntlShape): TextGetters["paginationTextGetter"] =>
  (payload) =>
    intl.formatMessage(messages.count, payload);

export const locationPaginationTextGetterFactory =
  (intl: IntlShape): TextGetters["paginationTextGetter"] =>
  (payload) =>
    intl.formatMessage(messages.countLocation, payload);

export const selectedPinsPaginationTextGetterFactory =
  (intl: IntlShape): TextGetters["paginationTextGetter"] =>
  (payload) =>
    intl.formatMessage(messages.countSelected, payload);

export const monoEntitiesPaginationTextGetterFactory =
  (
    intl: IntlShape,
    entityType?: EntityTypesSupportedByMapsPage
  ): TextGetters["paginationTextGetter"] =>
  (payload) =>
    intl.formatMessage(messages.countMono, { ...payload, entityType });
